var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCadastralAdvisory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8278 25.9999H30.7324C30.821 26.0007 30.9088 25.9837 30.9908 25.9502C31.0728 25.9166 31.1473 25.867 31.2099 25.8044C31.2726 25.7417 31.3221 25.6673 31.3557 25.5853C31.3893 25.5033 31.4062 25.4155 31.4055 25.3269V4.6592C31.406 4.56996 31.3889 4.4815 31.3549 4.39896C31.321 4.31643 31.271 4.24146 31.2078 4.17843L28.2271 1.19767C28.164 1.1345 28.0891 1.08449 28.0065 1.05056C27.924 1.01663 27.8355 0.99945 27.7463 1.00002H13.5583C13.4695 0.999316 13.3814 1.0162 13.2991 1.04971C13.2168 1.08322 13.142 1.13269 13.0789 1.19526C13.0158 1.25783 12.9658 1.33227 12.9316 1.41428C12.8975 1.49629 12.8799 1.58425 12.8799 1.6731L12.8799 5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3951 23.3019C28.2626 23.3019 29.7765 21.788 29.7765 19.9205C29.7765 18.053 28.2626 16.5391 26.3951 16.5391C24.5276 16.5391 23.0137 18.053 23.0137 19.9205C23.0137 21.788 24.5276 23.3019 26.3951 23.3019Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 19.9212L26.0585 21.2727L28.254 18.7354",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2764 9.10938H27.7464",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2275 7.0791H22.72",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2764 11.1338H27.7464",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2764 13.1631H27.7464",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0303 3.76209C28.0296 3.84297 28.045 3.92317 28.0756 3.99802C28.1062 4.07288 28.1515 4.14088 28.2086 4.19807C28.2658 4.25526 28.3338 4.30048 28.4087 4.3311C28.4835 4.36172 28.5637 4.37712 28.6446 4.37641H31.3155C31.2831 4.30316 31.2378 4.23624 31.182 4.17876L28.2279 1.198C28.1705 1.14216 28.1036 1.09695 28.0303 1.06445V3.76209Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13675 19.2529H19.8087C20.3754 19.2529 20.9189 19.478 21.3196 19.8788C21.7203 20.2795 21.9454 20.823 21.9454 21.3897V23.4463C21.9454 23.588 21.8892 23.7238 21.789 23.824C21.6888 23.9242 21.5529 23.9805 21.4113 23.9805H1.53419C1.39251 23.9805 1.25664 23.9242 1.15646 23.824C1.05628 23.7238 1 23.588 1 23.4463V21.3897C1 20.823 1.22512 20.2795 1.62584 19.8788C2.02656 19.478 2.57005 19.2529 3.13675 19.2529Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6378 10.4605H8.30769C8.15942 10.4589 8.01272 10.4299 7.875 10.375C8.2062 11.0641 9.10897 13.4733 9.10897 19.2425H13.8365C13.8365 13.4733 14.7393 11.0641 15.0705 10.375C14.9328 10.4299 14.7861 10.4589 14.6378 10.4605V10.4605Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.396 25.583C20.3561 25.7055 20.2781 25.812 20.1733 25.887C20.0686 25.962 19.9426 26.0015 19.8137 25.9997H3.1311C3.00229 26.0015 2.87628 25.962 2.77152 25.887C2.66676 25.812 2.58872 25.7055 2.54883 25.583L2.01465 23.9805H20.9355L20.396 25.583Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06641 17.2178H13.8794",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7981 5.05469H8.14747C7.55743 5.05469 7.0791 5.53301 7.0791 6.12306V9.39228C7.0791 9.98233 7.55743 10.4607 8.14747 10.4607H14.7981C15.3881 10.4607 15.8665 9.98233 15.8665 9.39228V6.12306C15.8665 5.53301 15.3881 5.05469 14.7981 5.05469Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastralAdvisory);
export default __webpack_public_path__ + "static/media/cadastral-advisory.5c58b28a172604e848af298fc0204d95.svg";
export { ForwardRef as ReactComponent };